import { Controller } from "@hotwired/stimulus"

// Handles membership filtering interactions and pushes form submissions through Turbo.
export default class extends Controller {
  static targets = ["form", "search", "status", "statusButton", "membershipType", "gender"]

  connect() {
    this.submit = this.submit.bind(this)
    this.searchTimeout = null
  }

  disconnect() {
    clearTimeout(this.searchTimeout)
  }

  search() {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => this.submit(), 500)
  }

  submit() {
    if (this.formTarget) {
      this.formTarget.requestSubmit()
    }
  }

  toggleStatus(event) {
    event.preventDefault()
    const { statusValue } = event.currentTarget.dataset
    this.statusTarget.value = this.statusTarget.value === statusValue ? "" : statusValue
    this.submit()
  }

  applyStatus(event) {
    event.preventDefault()
    const { statusValue } = event.currentTarget.dataset
    this.statusTarget.value = this.statusTarget.value === statusValue ? "" : statusValue
    this.submit()
  }

  clearStatus(event) {
    event.preventDefault()
    this.statusTarget.value = ""
    this.submit()
  }

  applyMembershipType(event) {
    event.preventDefault()
    const { membershipTypeValue } = event.currentTarget.dataset
    if (this.hasMembershipTypeTarget) {
      this.membershipTypeTarget.value =
        this.membershipTypeTarget.value === membershipTypeValue ? "" : membershipTypeValue
    }
    this.submit()
  }

  clearMembershipType(event) {
    event.preventDefault()
    if (this.hasMembershipTypeTarget) {
      this.membershipTypeTarget.value = ""
    }
    this.submit()
  }
}
